import { Route } from "@angular/router";
import { AdministrationLayout } from "../pages/administration/administration.layout";
import AccountingLayout from "../pages/administration/pages/accounting/accounting.layout";
import CenterStatLayout from "../pages/administration/pages/center-stat/center-stat.layout";

export const administrationRoutes: Route[] = [
    {
        path: "administration",
        component: AdministrationLayout,
        children: [
            {
                path: "",
                redirectTo: "center-stat",
                pathMatch: "full",
            },
            {
                path: "hrm",
                loadComponent: () =>
                    import("../pages/administration/pages/hrm/hrm.page"),
            },
            {
                path: "accounting",
                component: AccountingLayout,
                children: [
                    { path: "", redirectTo: "sales", pathMatch: "full" },
                    {
                        path: "sales",
                        loadComponent: () =>
                            import(
                                "../pages/administration/pages/accounting/sales/sales.page"
                            ),
                    },
                    {
                        path: "salary",
                        loadComponent: () =>
                            import(
                                "../pages/administration/pages/accounting/salary/salary.page"
                            ),
                    },
                ],
            },
            {
                path: "center-stat",
                component: CenterStatLayout,
                children: [
                    {
                        path: "",
                        redirectTo: "sales",
                        pathMatch: "full",
                    },
                    {
                        path: "sales",
                        loadComponent: () =>
                            import(
                                "../pages/administration/pages/center-stat/center-stat-sales/center-stat-sales.page"
                            ),
                    },
                    {
                        path: "salary",
                        loadComponent: () =>
                            import(
                                "../pages/administration/pages/center-stat/center-stat-salary/center-stat-salary.page"
                            ),
                    },
                    {
                        path: "session",
                        loadComponent: () =>
                            import(
                                "../pages/administration/pages/center-stat/center-stat-session/center-stat-session.page"
                            ),
                    },
                    {
                        path: "treatment",
                        loadComponent: () =>
                            import(
                                "../pages/administration/pages/center-stat/center-stat-treatment/center-stat-treatment.page"
                            ),
                    },
                    {
                        path: "counseling",
                        loadComponent: () =>
                            import(
                                "../pages/administration/pages/center-stat/center-stat-counseling/center-stat-counseling.page"
                            ),
                    },
                    {
                        path: "child",
                        loadComponent: () =>
                            import(
                                "../pages/administration/pages/center-stat/center-stat-child/center-stat-child.page"
                            ),
                    },
                ],
            },
        ],
    },
];
